import get from 'lodash.get';

import { cookieOptionDecider } from 'lib/cookies';

export const VIDEO_PLAYING_GLOBAL_EVENT = 'globalVideoPlaying';
export const VIDEO_PLAYING_EVENT_ATTENUATION = 'debounce';

/**
 * Tests video object for matching live video type.
 * @param {object} video
 */
export const isVideoLive = (video) => {
  const type = get(video, 'videoType', false);
  if (type && typeof type === 'string') {
    // Account for 'Non Broadcast Live Video' and 'nonBroadcastLiveVideo'
    return type.toLowerCase().replace(/\s+/, '') === 'nonbroadcastlivevideo';
  }
  return false;
};

// Autoplay related stuff
export const AUTOPLAY_TEST_GROUPS = {
  AUTOPLAY_ANY: 'AUTOPLAY_ANY',
  AUTOPLAY_UNMUTED_ONLY: 'AUTOPLAY_UNMUTED_ONLY',
  AUTOPLAY_DISABLED: 'AUTOPLAY_DISABLED',
};

export const AUTOPLAY_TEST_AD_KVS = {
  [AUTOPLAY_TEST_GROUPS.AUTOPLAY_ANY]: 'a',
  [AUTOPLAY_TEST_GROUPS.AUTOPLAY_UNMUTED_ONLY]: 'b',
  [AUTOPLAY_TEST_GROUPS.AUTOPLAY_DISABLED]: 'c',
};

export function getAutoplayTestGroup({
  AUTOPLAY_TEST_ANY_PERCENTAGE,
  AUTOPLAY_TEST_UNMUTED_PERCENTAGE,
  AUTOPLAY_TEST_DISABLED_PERCENTAGE,
}) {
  const groups = [
    [AUTOPLAY_TEST_GROUPS.AUTOPLAY_ANY, AUTOPLAY_TEST_ANY_PERCENTAGE],
    [AUTOPLAY_TEST_GROUPS.AUTOPLAY_UNMUTED_ONLY, AUTOPLAY_TEST_UNMUTED_PERCENTAGE],
    [AUTOPLAY_TEST_GROUPS.AUTOPLAY_DISABLED, AUTOPLAY_TEST_DISABLED_PERCENTAGE],
  ];

  return cookieOptionDecider(groups);
}

export default {
  isVideoLive,
  getAutoplayTestGroup,
};
